/*
 * Sticker Studio: Reorder page (sections/reorder.liquid)
 * Maps old order lines (Shopify era and imported OpenCart orders) to the
 * product's current options, then links to the product page with the
 * matching variant preselected, the old PitchPrint design and a
 * "Reprint of" reference. Nothing is added to the cart from here.
 */
(function (root) {
  'use strict';

  /* OpenCart order id -> month it was placed (first id of each month). */
  var OC_MONTHS = [[1,201401],[17,201402],[43,201404],[67,201405],[87,201406],[127,201407],[157,201408],[187,201409],[230,201410],[303,201411],[383,201412],[430,201501],[495,201502],[572,201503],[653,201504],[724,201505],[815,201506],[909,201507],[1019,201508],[1145,201509],[1249,201510],[1367,201511],[1519,201512],[1608,201601],[1712,201602],[1836,201603],[1941,201604],[2026,201605],[2108,201606],[2185,201607],[2280,201608],[2435,201609],[2562,201610],[2704,201611],[2850,201612],[2936,201701],[3039,201702],[3162,201703],[3284,201704],[3395,201705],[3518,201706],[3666,201707],[3814,201708],[3975,201709],[4068,201710],[4208,201711],[4357,201712],[4421,201801],[4483,201802],[4563,201803],[4655,201804],[4745,201805],[4829,201806],[4913,201807],[5012,201808],[5126,201809],[5199,201810],[5273,201811],[5356,201812],[5415,201901],[5490,201902],[5556,201903],[5614,201904],[5662,201905],[5741,201906],[5813,201907],[5868,201908],[5920,201909],[5996,201910],[6088,201911],[6195,201912],[6267,202001],[6348,202002],[6431,202003],[6504,202004],[6591,202005],[6648,202006],[6753,202007],[6871,202008],[6961,202009],[7102,202010],[7229,202011],[7350,202012],[7468,202101],[7555,202102],[7658,202103],[7793,202104],[7909,202105],[8007,202106],[8131,202107],[8260,202108],[8380,202109],[8498,202110],[8597,202111],[8730,202112],[8781,202201],[8846,202202],[9023,202203],[9125,202204],[9207,202205],[9300,202206],[9374,202207],[9470,202208],[9595,202209],[9713,202210],[9821,202211],[9901,202212],[10044,202301],[10137,202302],[10266,202303],[10359,202304],[10442,202305],[10553,202306],[10630,202307],[10679,202308],[10756,202309],[10845,202310],[10962,202311],[11082,202312],[11128,202401],[11200,202402],[11302,202403],[11415,202404],[11508,202405],[11577,202406],[11641,202407],[11702,202408],[11759,202409],[11817,202410],[11892,202411],[11983,202412],[12014,202501],[12048,202502],[12096,202503],[12163,202504],[12218,202505],[12283,202506],[12355,202507],[12407,202508],[12459,202509],[12516,202510],[12558,202511],[12609,202512],[12627,202601],[12656,202602],[12706,202603]];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  /* Imported OpenCart orders were created in Shopify between these dates. */
  var IMPORT_LAST_DAY = '2026-03-17';
  var PREVIEW_BASE = 'https://s3-eu-west-1.amazonaws.com/pitchprint.io/previews/';
  var QTY_OPTION = 'printed quantity';
  var SIZE_KEYS_EXCLUDED = ['my decal required size', 'character count check'];

  var MAT_ALIAS = {
    'gloss white vinyl': ['gloss vinyl'],
    'matt white vinyl': ['matt vinyl'],
    'gloss white vinyl longlife': ['long life gloss vinyl'],
    'gloss white vinyl long life': ['long life gloss vinyl'],
    'gloss vinyl longlife': ['long life gloss vinyl'],
    'gloss vinyl long life': ['long life gloss vinyl'],
    'matt white synthetic': ['matt synthetic pp'],
    'matt synthetic': ['matt synthetic pp'],
    'gloss white synthetic': ['gloss synthetic pp'],
    'gloss synthetic': ['gloss synthetic pp'],
    'matt pp': ['matt synthetic pp'],
    'gloss pp': ['gloss synthetic pp'],
    'matt white pp': ['matt synthetic pp'],
    'gloss white pp': ['gloss synthetic pp'],
    'clear vinyl longlife': ['clear vinyl']
  };

  /* ---------- normalisers ---------- */
  function unent(s) {
    return String(s == null ? '' : s).replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
  }
  function nsize(s) {
    s = unent(s).toLowerCase();
    s = s.replace(/\(.*?\)/g, '');
    s = s.replace(/diameter|wide|high|dia/g, '');
    s = s.replace(/\u00d7/g, 'x').replace(/\s+/g, '').replace(/mmx/g, 'x').replace(/mm/g, '');
    return s;
  }
  function nmat(s) {
    return unent(s).toLowerCase().replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim();
  }
  function nstock(s) {
    var l = unent(s).toLowerCase();
    if (l.indexOf('block') !== -1) return 'blockout';
    if (l.indexOf('standard') !== -1) return 'standard';
    return nmat(s);
  }
  function kindOf(optName) {
    var l = String(optName).toLowerCase();
    if (l === QTY_OPTION) return 'qty';
    if (l.indexOf('size') !== -1) return 'size';
    if (l.indexOf('material') !== -1) return 'material';
    if (l.indexOf('stock') !== -1) return 'stock';
    return 'other';
  }

  /* Find the current option value that matches an old value, or null. */
  function matchValue(optName, raw, values) {
    if (raw == null || raw === '') return null;
    var kind = kindOf(optName);
    var i;
    if (kind === 'size') {
      var want = nsize(raw);
      for (i = 0; i < values.length; i++) if (nsize(values[i]) === want) return values[i];
      return null;
    }
    if (kind === 'material') {
      var m = nmat(raw);
      var wants = (MAT_ALIAS[m] || []).concat([m]);
      for (var w = 0; w < wants.length; w++) {
        for (i = 0; i < values.length; i++) if (nmat(values[i]) === wants[w]) return values[i];
      }
      return null;
    }
    if (kind === 'stock') {
      var st = nstock(raw);
      for (i = 0; i < values.length; i++) if (nstock(values[i]) === st) return values[i];
      return null;
    }
    var o = nmat(raw);
    for (i = 0; i < values.length; i++) if (nmat(values[i]) === o) return values[i];
    return null;
  }

  /* ---------- reading an old line ---------- */
  function orderIsLegacy(order) {
    var name = String(order.name || '').replace(/^#/, '');
    return /^\d+$/.test(name) && String(order.created || '') <= IMPORT_LAST_DAY && parseInt(name, 10) < 20000;
  }

  function orderRef(order) {
    var name = String(order.name || '').trim();
    if (order.legacy) return name.replace(/^#/, '');
    return name;
  }

  function orderLabel(order) {
    var ref = orderRef(order);
    return 'Order ' + (/^\d+$/.test(ref) ? '#' + ref : ref);
  }

  /* Approximate month for an imported OpenCart order. */
  function legacyMonth(num) {
    num = parseInt(num, 10);
    if (!num) return null;
    var hit = null;
    for (var i = 0; i < OC_MONTHS.length; i++) {
      if (OC_MONTHS[i][0] <= num) hit = OC_MONTHS[i][1];
      else break;
    }
    if (!hit) return null;
    var y = Math.floor(hit / 100), m = hit % 100;
    return { year: y, month: m, label: MONTHS[m - 1] + ' ' + y };
  }

  function projectIdFrom(line, legacy) {
    var props = line.props || {};
    if (props._pitchprint && /^[0-9a-f]{20,40}$/i.test(props._pitchprint)) return String(props._pitchprint).toLowerCase();
    var di = props['Design Input'];
    if (!di) return null;
    var s = String(di);
    try { s = decodeURIComponent(s); } catch (e) { /* keep raw */ }
    s = unent(s);
    var m = s.match(/"projectId"\s*:\s*"([0-9a-f]{20,40})"/i) || s.match(/p:([0-9a-f]{20,40})/i);
    return m ? m[1].toLowerCase() : null;
  }

  function snapshotTitle(line) {
    if (line.vt) return String(line.vt);
    var t = String(line.title || ''), pt = String(line.ptitle || '');
    if (pt && t.indexOf(pt + ' - ') === 0) return t.slice(pt.length + 3);
    if (t === pt) return '';
    var i = t.lastIndexOf(' - ');
    return i >= 0 ? t.slice(i + 3) : '';
  }

  function sizeProp(props) {
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      var l = k.toLowerCase();
      if (SIZE_KEYS_EXCLUDED.indexOf(l) !== -1) continue;
      if (l.indexOf('size') !== -1) return props[k];
    }
    return null;
  }

  /* Human readable "what you ordered" text (never shows hidden or staff fields). */
  function oldOptionsText(line, legacy) {
    var parts = [];
    var props = line.props || {};
    if (!legacy) {
      var snap = snapshotTitle(line);
      if (snap) parts.push(snap.replace(/\s*-{2,}.*$/, '').split(' / ').join(', '));
    }
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (k.charAt(0) === '_' || k === 'Design Input' || k === 'Design' || k === 'Reprint of') continue;
      var v = unent(props[k]);
      if (!v || v.length > 80 || /[<>{}]/.test(v)) continue;
      parts.push(k + ': ' + v);
    }
    return parts;
  }

  /*
   * Single sided service stickers. The current service sticker products are double sided only,
   * and there is no single sided product with the old sizes (40x60mm, 46x70mm, round 45 to 60mm)
   * and window stock, so these lines go to "Request a reprint" instead of a double sided product.
   * OpenCart lines: trust the "Number of Sides" property (their imported variant titles are not reliable).
   * Shopify era lines: the variant title snapshot, e.g. "40x60mm / Single Sided / Standard Stock".
   */
  function isSingleSided(line, legacy) {
    var props = line.props || {};
    var sides = props['Number of Sides'];
    if (sides != null) return /single/i.test(unent(sides));
    if (legacy) return false;
    return /(^|\/)\s*single\s*sided\s*($|\/)/i.test(snapshotTitle(line));
  }

  /* ---------- mapping ---------- */
  function pickTier(q, values) {
    var t = values.map(function (v) { return parseInt(v, 10); }).filter(function (n) { return n > 0; }).sort(function (a, b) { return a - b; });
    for (var i = 0; i < t.length; i++) if (t[i] >= q) return { tier: t[i], how: t[i] === q ? 'exact' : 'rounded', min: t[0], max: t[t.length - 1] };
    return { tier: null, how: 'over_max', min: t[0], max: t[t.length - 1] };
  }

  function valuesOf(opt) {
    return (opt.values || []).map(function (v) { return typeof v === 'string' ? v : v.name; });
  }

  /*
   * line:    data emitted by sections/reorder.liquid for one line item
   * order:   { name, created, legacy }
   * product: data from /products/<handle>?view=reorder-data, or null
   * Returns { status: ok | quote | manual, reason, selected, qty, notes[] }
   */
  function mapLine(line, order, product) {
    var legacy = order.legacy || !!(line.props && line.props['Design Input']);
    var res = { status: 'manual', reason: null, selected: {}, notes: [], legacy: legacy, qty: line.qty, handle: line.handle || null };
    if (!line.handle) { res.reason = 'no_product'; return res; }
    if (isSingleSided(line, legacy)) { res.reason = 'single_sided'; res.noSelfServe = true; return res; }
    if (!product) { res.reason = 'product_unavailable'; return res; }
    if (product.available === false) { res.reason = 'product_unavailable'; return res; }

    var props = line.props || {};
    var tokens = legacy ? [] : snapshotTitle(line).split(' / ').map(function (s) { return s.trim(); }).filter(Boolean);
    var used = {};
    var qtyOpt = null;
    var native = false;
    var problems = [];

    product.options.forEach(function (opt, idx) {
      var name = opt.name, values = valuesOf(opt), kind = kindOf(name);
      if (kind === 'qty') { qtyOpt = opt; native = true; return; }
      if (values.length === 1) { res.selected[name] = values[0]; return; }
      var hit = null, raw = null;
      if (legacy) {
        if (kind === 'size') raw = props[name] != null ? props[name] : sizeProp(props);
        else if (kind === 'material') raw = props.Material != null ? props.Material : (props['DECAL MATERIAL'] != null ? props['DECAL MATERIAL'] : props[name]);
        else if (kind === 'stock') {
          raw = props['Standard or Blockout Stock'] != null ? props['Standard or Blockout Stock'] : props[name];
          if (raw == null) { raw = 'Standard'; res.notes.push('stock_assumed_standard'); }
        } else raw = props[name];
        hit = matchValue(name, raw, values);
      } else {
        for (var t = 0; t < tokens.length && !hit; t++) {
          if (used[t]) continue;
          var h = matchValue(name, tokens[t], values);
          if (h) { hit = h; used[t] = true; raw = tokens[t]; }
        }
        if (!hit && props[name] != null) { raw = props[name]; hit = matchValue(name, raw, values); }
        if (!hit && kind === 'stock' && tokens.length) { raw = 'Standard'; hit = matchValue(name, raw, values); if (hit) res.notes.push('stock_assumed_standard'); }
        /* Kept variant IDs still carry the same size and material. */
        if (!hit && line.vid && line.vopts && line.vopts[idx] && values.indexOf(line.vopts[idx]) !== -1 && line.vprod === product.id) {
          hit = line.vopts[idx]; res.notes.push('from_current_variant');
        }
      }
      if (hit) res.selected[name] = hit;
      else problems.push({ option: name, old: raw == null ? null : unent(raw) });
    });

    if (native) {
      var qvals = valuesOf(qtyOpt);
      var snapQty = null;
      if (!legacy) {
        for (var t2 = 0; t2 < tokens.length; t2++) {
          if (!used[t2] && /^\d+$/.test(tokens[t2]) && qvals.indexOf(tokens[t2]) !== -1) { snapQty = tokens[t2]; break; }
        }
      }
      if (snapQty) {
        res.selected[qtyOpt.name] = snapQty;
        res.qtyHow = 'exact';
        res.printed = parseInt(snapQty, 10);
        res.jobs = line.qty;
      } else {
        var pt = pickTier(line.qty, qvals);
        res.qtyHow = pt.how; res.tierMin = pt.min; res.tierMax = pt.max;
        if (pt.tier) { res.selected[qtyOpt.name] = String(pt.tier); res.printed = pt.tier; }
      }
    } else {
      res.qtyHow = 'same';
      res.cartQty = line.qty;
    }

    res.native = native;
    if (problems.length) {
      res.problems = problems;
      var missing = problems.every(function (p) { return p.old == null; });
      res.reason = missing ? 'option_missing' : 'option_not_offered';
      return res;
    }
    if (res.qtyHow === 'over_max') { res.status = 'quote'; res.reason = 'over_max'; return res; }
    res.status = 'resolve';
    return res;
  }

  function findVariant(product, selected) {
    var names = product.options.map(function (o) { return o.name; });
    var list = product.variants || [];
    for (var i = 0; i < list.length; i++) {
      var v = list[i], ok = true;
      for (var j = 0; j < names.length; j++) {
        if (selected[names[j]] !== undefined && v.options[j] !== selected[names[j]]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function optionValueIds(product, selected) {
    var ids = [];
    for (var i = 0; i < product.options.length; i++) {
      var o = product.options[i], want = selected[o.name], found = null;
      (o.values || []).forEach(function (v) { if (typeof v === 'object' && v.name === want) found = v.id; });
      if (!found) return null;
      ids.push(found);
    }
    return ids;
  }

  var api = {
    nsize: nsize, nmat: nmat, nstock: nstock, matchValue: matchValue, pickTier: pickTier,
    mapLine: mapLine, findVariant: findVariant, optionValueIds: optionValueIds, projectIdFrom: projectIdFrom,
    snapshotTitle: snapshotTitle, oldOptionsText: oldOptionsText, orderIsLegacy: orderIsLegacy,
    orderRef: orderRef, orderLabel: orderLabel, legacyMonth: legacyMonth, isSingleSided: isSingleSided
  };
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  root.SSReorder = api;

  /* =================== Browser UI =================== */
  var doc = root.document;
  var page = doc.getElementById('ss-reorder');
  if (!page) return;

  var themeId = root.Shopify && root.Shopify.theme ? root.Shopify.theme.id : '';
  var isPreview = root.Shopify && root.Shopify.theme && root.Shopify.theme.role !== 'main';
  var CACHE_PREFIX = 'ssro:v1:' + themeId + ':';
  var CACHE_TTL = 10 * 60 * 1000;
  var mem = {};
  var queue = [], active = 0, MAX_ACTIVE = 4;

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(n); } catch (e) { return '$' + n.toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function withPreview(url) {
    if (!isPreview || !themeId) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + themeId;
  }

  function schedule(fn) {
    return new Promise(function (resolve, reject) {
      queue.push(function () { return fn().then(resolve, reject); });
      pump();
    });
  }
  function pump() {
    while (active < MAX_ACTIVE && queue.length) {
      var job = queue.shift();
      active++;
      job().catch(function () {}).then(function () { active--; pump(); });
    }
  }

  function fetchProductData(handle, optionValues) {
    var url = '/products/' + encodeURIComponent(handle) + '?view=reorder-data';
    if (optionValues) url += '&option_values=' + optionValues.join(',');
    return schedule(function () {
      return fetch(withPreview(url), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) return null;
        return r.text().then(function (t) {
          try { return JSON.parse(t); } catch (e) { return null; }
        });
      });
    });
  }

  function getProduct(handle) {
    if (mem[handle]) return mem[handle];
    try {
      var c = JSON.parse(root.sessionStorage.getItem(CACHE_PREFIX + handle) || 'null');
      if (c && Date.now() - c.t < CACHE_TTL) { mem[handle] = Promise.resolve(c.d); return mem[handle]; }
    } catch (e) { /* ignore */ }
    mem[handle] = fetchProductData(handle).then(function (d) {
      try { root.sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* quota */ }
      return d;
    });
    return mem[handle];
  }

  function resolveVariant(product, selected) {
    var v = findVariant(product, selected);
    if (v) return Promise.resolve(v);
    var count = product.variants_count || 0;
    if (count <= (product.variants || []).length) return Promise.resolve(null);
    var ids = optionValueIds(product, selected);
    if (!ids) return Promise.resolve(null);
    return fetchProductData(product.handle, ids).then(function (d) {
      if (!d || !d.selected) return null;
      var sv = d.selected;
      var names = product.options.map(function (o) { return o.name; });
      for (var j = 0; j < names.length; j++) if (sv.options[j] !== selected[names[j]]) return null;
      return sv;
    });
  }

  function checkDesign(pid) {
    return new Promise(function (resolve) {
      if (!pid) return resolve(null);
      var img = new Image();
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; resolve(null); } }, 8000);
      img.onload = function () { if (!done) { done = true; clearTimeout(timer); resolve(img.naturalWidth > 1 ? img.src : null); } };
      img.onerror = function () { if (!done) { done = true; clearTimeout(timer); resolve(null); } };
      img.src = PREVIEW_BASE + pid + '_1.jpg';
    });
  }

  /* Base product URL. The old PitchPrint project is never opened directly: it only travels as
     rsrc (traced in the hidden _reprint_source_project property). A copy is made on click, see goReorder. */
  function productUrl(res, line, order, variant, srcPid) {
    var q = [];
    if (variant) q.push('variant=' + variant.id);
    q.push('reorder=' + encodeURIComponent(orderRef(order)));
    if (order.lineCount > 1 && line.n) q.push('ritem=' + line.n);
    if (srcPid) q.push('rsrc=' + srcPid);
    if (res && res.cartQty && res.cartQty > 1) q.push('rqty=' + res.cartQty);
    /* Carry visible custom fields (e.g. My Decal Required Size); the product page only fills matching inputs. */
    var props = (order.legacy || (line.props && line.props['Design Input'])) ? {} : (line.props || {}), carried = 0;
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k) || carried >= 6) continue;
      if (k.charAt(0) === '_' || k === '__end' || k === 'Design Input' || k === 'Design' || k === 'Reprint of') continue;
      var v = unent(props[k]);
      if (!v || v.length > 80 || /[<>{}]/.test(v)) continue;
      q.push('rp.' + encodeURIComponent(k) + '=' + encodeURIComponent(v));
      carried++;
    }
    return '/products/' + encodeURIComponent(line.handle) + '?' + q.join('&');
  }

  /* ---- PitchPrint copy (same API PitchPrint's own "Duplicate design for reorder" uses) ---- */
  var PP_API = 'https://api.pitchprint.io/client/';
  var HEX = /^[0-9a-f]{20,40}$/i;
  function ppPost(path, body) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', PP_API + path, true);
      x.withCredentials = true;
      x.timeout = 15000;
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      x.onload = function () {
        var d = null;
        try { d = JSON.parse(x.responseText); } catch (e) { return reject(new Error('bad response')); }
        try { if (d && d.token) root.localStorage.setItem('pptoken', d.token); } catch (e) { /* private mode */ }
        resolve(d);
      };
      x.onerror = x.ontimeout = function () { reject(new Error('network')); };
      x.send(JSON.stringify(body));
    });
  }
  function ppToken(fresh) {
    var t = null;
    try { t = fresh ? null : root.localStorage.getItem('pptoken'); } catch (e) { /* ignore */ }
    if (t) return Promise.resolve(t);
    var cid = (root.__st && root.__st.cid) || page.dataset.customerId || 'guest';
    return ppPost('init', { userId: String(cid), apiKey: (root.Shopify && root.Shopify.shop) || '', client: 'sp', version: '9.1.0' })
      .then(function (d) { if (!d || d.error || !d.token) throw new Error('init'); return d.token; });
  }
  function cloneProject(pid) {
    function attempt(fresh) {
      return ppToken(fresh).then(function (tok) {
        return ppPost('clone-project', { values: 1, id: pid, token: tok });
      }).then(function (d) {
        if (!d || d.error || !d.newId || !HEX.test(d.newId) || d.newId === pid) throw new Error('clone');
        return d.newId;
      });
    }
    return attempt(false).catch(function () { return attempt(true); });
  }
  /* Number of pages (sides) of a project, from its preview images (<id>_1.jpg, <id>_2.jpg, ...).
     Checks the copy, then the original (copies have identical previews). Defaults to 1. */
  function imgOk(url) {
    return new Promise(function (resolve) {
      var im = new Image(), done = false;
      var end = function (ok) { if (!done) { done = true; resolve(ok); } };
      im.onload = function () { end(im.naturalWidth > 0); };
      im.onerror = function () { end(false); };
      setTimeout(function () { end(false); }, 5000);
      im.src = url;
    });
  }
  function countPages(id) {
    var checks = [];
    for (var i = 1; i <= 4; i++) checks.push(imgOk(PREVIEW_BASE + id + '_' + i + '.jpg'));
    return Promise.all(checks).then(function (r) { var n = 0; while (n < r.length && r[n]) n++; return n; });
  }
  function pageCount(copyId, srcId) {
    return countPages(copyId).then(function (n) {
      return n || (srcId ? countPages(srcId) : 0);
    }).then(function (n) { return n || 1; }, function () { return 1; });
  }
  /* Click on Reorder: copy the old design first, then open the product with the copy. */
  function goReorder(a, ev) {
    var src = a.getAttribute('data-ro-clone');
    if (!src || !HEX.test(src)) return;
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button > 0) return; /* new tab: plain link, artwork note */
    ev.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    a.classList.add('is-busy');
    var label = a.textContent;
    if (a.classList.contains('ss-ro-btn')) a.textContent = 'Copying your design...';
    var base = a.getAttribute('href');
    cloneProject(src).then(function (newId) {
      /* PitchPrint only shows the design as the product image when it is told how many pages the
         project has (numPages); without it, it replaces the gallery with an empty image. */
      return pageCount(newId, src).then(function (n) {
        root.location.href = base + '&projectId=' + newId + '&resume=true&numPages=' + n + '&rpp=' + newId;
      });
    }).catch(function () {
      root.location.href = base + '&rnocopy=1';
    }).then(function () {
      setTimeout(function () { a.removeAttribute('aria-busy'); a.classList.remove('is-busy'); a.textContent = label; }, 4000);
    });
  }

  function selectedText(product, selected) {
    return product.options.filter(function (o) { return o.name !== 'Title'; }).map(function (o) {
      var v = selected[o.name];
      return kindOf(o.name) === 'qty' ? v + ' printed' : v;
    }).join(', ');
  }

  function reasonText(res) {
    switch (res.reason) {
      case 'single_sided':
        return 'Single sided service stickers are not in our online shop right now, but we can still print them for you.';
      case 'no_product':
      case 'product_unavailable':
        return 'This item is not in our online shop any more, but we can still print it for you.';
      case 'option_not_offered':
        return 'We no longer offer ' + res.problems.map(function (p) { return p.old ? p.old : p.option.toLowerCase(); }).join(' or ') + ' online, but we can still help.';
      case 'option_missing':
        return 'We could not work out the ' + res.problems.map(function (p) { return p.option.toLowerCase(); }).join(' and ') + ' from your old order.';
      case 'variant_not_found':
        return 'That combination is not available online any more, but we can still help.';
      default:
        return 'We can reprint this for you. Send us a quick request and we will get back to you.';
    }
  }

  /* Item name for the request. Imported OpenCart lines carry an unreliable variant part, so only the
     product name is used for them; the real options come from oldParts. Long "---" notes are dropped. */
  function requestTitle(line, order) {
    var t = unent(line.title || line.ptitle || '');
    var legacy = order.legacy || !!(line.props && line.props['Design Input']);
    var snap = snapshotTitle(line);
    if (legacy && snap) {
      var cut = t.lastIndexOf(' - ' + snap);
      t = cut > 0 ? t.slice(0, cut) : (line.ptitle ? unent(line.ptitle) : t);
    }
    return t.replace(/\s*-{2,}[^/]*/g, '').trim();
  }

  function requestText(kind, order, line, oldParts) {
    var first = page.dataset.customerFirst || '';
    var lines = [];
    lines.push('Hi Sticker Studio,');
    lines.push('');
    lines.push((kind === 'quote' ? 'Please send me a quote to reprint this item from ' : 'Please reprint this item from ') + orderLabel(order) + (order.dateLabel ? ' (' + order.dateLabel + ')' : '') + ':');
    lines.push(requestTitle(line, order));
    if (oldParts.length) lines.push(oldParts.join(', '));
    lines.push('Quantity: ' + line.qty);
    lines.push('');
    lines.push('Thanks' + (first ? ',\n' + first : ''));
    return lines.join('\n');
  }

  function openRequest(kind, order, line, oldParts) {
    var dlg = doc.getElementById('ss-ro-request');
    if (!dlg) return;
    var body = dlg.querySelector('textarea');
    var subj = dlg.querySelector('[data-ro-subject]');
    var title = dlg.querySelector('[data-ro-title]');
    if (body) body.value = requestText(kind, order, line, oldParts);
    if (subj) subj.value = (kind === 'quote' ? 'Reprint quote request: ' : 'Reprint request: ') + orderLabel(order);
    if (title) title.textContent = kind === 'quote' ? 'Request a quote' : 'Request a reprint';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function renderLine(li, order) {
    var dataEl = li.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var line;
    try { line = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var oldEl = li.querySelector('.js-ro-old');
    var newEl = li.querySelector('.js-ro-new');
    var actEl = li.querySelector('.js-ro-actions');
    var imgEl = li.querySelector('.js-ro-img');
    var legacy = order.legacy || !!(line.props && line.props['Design Input']);
    var oldParts = oldOptionsText(line, legacy);
    if (oldEl) oldEl.textContent = (oldParts.length ? oldParts.join(', ') + '. ' : '') + 'Quantity ' + line.qty + '.';
    var pid = projectIdFrom(line, legacy);

    function manual(res) {
      newEl.innerHTML = '<span class="ss-ro-muted">' + esc(reasonText(res)) + '</span>';
      actEl.innerHTML = '<button type="button" class="btn btn--secondary ss-ro-btn js-ro-request">Request a reprint</button>' +
        (res.handle && res.reason !== 'product_unavailable' && !res.noSelfServe ? '<a class="ss-ro-sublink" href="' + esc(productUrl(null, line, order, null, pid)) + '">Or choose new options yourself</a>' : '');
      actEl.querySelector('.js-ro-request').addEventListener('click', function () { openRequest('reprint', order, line, oldParts); });
      li.dataset.status = 'manual';
    }

    var productP = line.handle ? getProduct(line.handle) : Promise.resolve(null);
    Promise.all([productP, checkDesign(pid)]).then(function (r) {
      var product = r[0], preview = r[1];
      if (preview && imgEl) {
        imgEl.innerHTML = '<img src="' + esc(preview) + '" alt="Your design" loading="lazy" width="120" height="120">';
        li.classList.add('has-design');
      }
      var res = mapLine(line, order, product);
      li.dataset.reason = res.reason || '';
      if (res.status === 'manual') {
        if (res.handle && product && res.reason !== 'product_unavailable' && !res.noSelfServe) {
          manual(res);
          var sub = actEl.querySelector('.ss-ro-sublink');
          if (sub && preview) {
            sub.setAttribute('data-ro-clone', pid);
            sub.addEventListener('click', function (ev) { goReorder(sub, ev); });
          }
        } else manual(res);
        return;
      }
      if (res.status === 'quote') {
        newEl.innerHTML = '<span class="ss-ro-muted">You ordered ' + esc(line.qty) + '. That is more than we can price online (up to ' + esc(res.tierMax) + '), so we will send you a quote.</span>';
        actEl.innerHTML = '<button type="button" class="btn btn--primary ss-ro-btn js-ro-request">Request a quote</button>';
        actEl.querySelector('.js-ro-request').addEventListener('click', function () { openRequest('quote', order, line, oldParts); });
        li.dataset.status = 'quote';
        return;
      }
      resolveVariant(product, res.selected).then(function (variant) {
        if (!variant || variant.available === false) { res.reason = 'variant_not_found'; manual(res); return; }
        var url = productUrl(res, line, order, variant, pid);
        var html = '<span class="ss-ro-label">Today:</span> <span class="ss-ro-now">' + esc(selectedText(product, res.selected)) + '</span>';
        html += ' <span class="ss-ro-price">' + esc(money(variant.price)) + (res.cartQty > 1 ? ' each' : '') + '</span>';
        var notes = [];
        if (res.qtyHow === 'rounded') {
          notes.push(line.qty < res.tierMin
            ? 'You had ' + line.qty + ' last time. The smallest run we print now is ' + res.printed + '.'
            : 'You had ' + line.qty + ' last time. We now print in set quantities, so we picked the next one up, ' + res.printed + '.');
        }
        if (res.jobs > 1) notes.push('Last time you ordered ' + res.jobs + ' lots of this. Add each lot you need to your cart.');
        if (res.cartQty > 1) notes.push('We will pick quantity ' + res.cartQty + ', or the next size up, on the product page.');
        if (preview) notes.push('We will load a copy of your design, so your original stays as it was.');
        else notes.push('We will use the artwork from your original order.');
        html += '<span class="ss-ro-note">' + notes.map(esc).join(' ') + '</span>';
        newEl.innerHTML = html;
        actEl.innerHTML = '<a class="btn btn--primary ss-ro-btn js-ro-go" href="' + esc(url) + '"' + (preview ? ' data-ro-clone="' + esc(pid) + '"' : '') + '>Reorder</a>' +
          '<span class="ss-ro-hint">Opens the product with your options picked. Check the price, then add to cart.</span>' +
          (preview ? '' : '<button type="button" class="ss-ro-sublink ss-ro-linkbtn js-ro-request">Or ask us to reprint it from your old artwork</button>');
        var rq = actEl.querySelector('.js-ro-request');
        if (rq) rq.addEventListener('click', function () { openRequest('reprint', order, line, oldParts); });
        var go = actEl.querySelector('.js-ro-go');
        if (go && preview) go.addEventListener('click', function (ev) { goReorder(go, ev); });
        li.dataset.status = 'ok';
      });
    }).catch(function () {
      manual({ reason: null, handle: null });
    });
  }

  function init() {
    var orders = page.querySelectorAll('.js-ro-order');
    Array.prototype.forEach.call(orders, function (el) {
      var order = { name: el.dataset.orderName, created: el.dataset.created };
      order.legacy = orderIsLegacy(order);
      var lines = el.querySelectorAll('.js-ro-line');
      order.lineCount = parseInt(el.dataset.lineCount, 10) || lines.length;
      if (order.legacy) {
        var lm = legacyMonth(orderRef(order));
        var dateEl = el.querySelector('.js-ro-date');
        if (lm) { order.dateLabel = lm.label; if (dateEl) dateEl.textContent = lm.label; }
        var labelEl = el.querySelector('.js-ro-label');
        if (labelEl) labelEl.textContent = orderLabel(order);
      } else {
        order.dateLabel = el.dataset.dateLabel || '';
      }
      Array.prototype.forEach.call(lines, function (li) { renderLine(li, order); });
    });
    var dlg = doc.getElementById('ss-ro-request');
    var posted = /[?&]contact_posted=true/.test(root.location.search) || (dlg && dlg.querySelector('[data-ro-posted-ok]'));
    var okBanner = page.querySelector('[data-ro-posted]');
    if (posted && okBanner && !(dlg && dlg.querySelector('[data-ro-errors]'))) okBanner.hidden = false;
    if (dlg && dlg.querySelector('[data-ro-errors]')) {
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    }
    if (dlg) {
      Array.prototype.forEach.call(dlg.querySelectorAll('.js-ro-close'), function (b) {
        b.addEventListener('click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
      });
    }
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})(typeof window !== 'undefined' ? window : this);
